module.exports = __webpack_public_path__ + "fonts/oktaVerify@2x.364f868952df7f5961ce9fbbfcbbbebb.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/oktaVerify@2x.png
// module id = 742
// module chunks = 9